import { connect } from 'react-redux';
import UserAPI from '../apis/user';
import RegisterConfirmation from '../components/pages/register-confirmation';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({
    async checkregistration(token, locale, callback) {
        const params = {
            tokens: token,
            locale: locale.currentLocale,
        };
        const registerPromise = UserAPI.registerByEmail(params);

        return registerPromise;
    },

});

const RegisterConfirmationConnector = connect(mapStateToProps, mapDispatchToProps)(RegisterConfirmation);

export default RegisterConfirmationConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/register-confirmation-connector.js
 **/